import { render, staticRenderFns } from "./PdfTemplateTextsTable.vue?vue&type=template&id=0068972b&scoped=true&"
import script from "./PdfTemplateTextsTable.vue?vue&type=script&lang=js&"
export * from "./PdfTemplateTextsTable.vue?vue&type=script&lang=js&"
import style0 from "./PdfTemplateTextsTable.vue?vue&type=style&index=0&id=0068972b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0068972b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
